"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObfuscationEventEmitter = void 0;
const inversify_1 = require("inversify");
const eventemitter3_1 = __importDefault(require("eventemitter3"));
inversify_1.decorate(inversify_1.injectable(), eventemitter3_1.default);
let ObfuscationEventEmitter = class ObfuscationEventEmitter extends eventemitter3_1.default {
};
ObfuscationEventEmitter = __decorate([
    inversify_1.injectable()
], ObfuscationEventEmitter);
exports.ObfuscationEventEmitter = ObfuscationEventEmitter;
